module.exports = function getResource(label, vars = []) {
    let resources = {
        done: 'Terminé',
        close: 'Fermer',
        cancel: 'Annuler',
        continue: 'Continuer',
        sephoraCreditCard: 'Carte de crédit Sephora',
        noThanks: 'Non merci',
        acceptNow: 'Accepter maintenant',
        fromTheRewardsBazaar: 'De la foire aux récompenses Rewards Bazaar',
        droppingTimeText: 'De nouvelles récompenses sont lancées chaque mardi et jeudi de 9 h à 17 h HNP. Elles s’envolent à la vitesse de l’éclair, alors revenez souvent pour décrocher des expériences, des services personnalisés et des échantillons récompense convoités.',
        oops: 'Oups',
        cannotExtendText: 'Nous n’avons pas pu prolonger votre session. Veuillez réessayer plus tard.',
        youEntered: 'Vous avez saisi :',
        recommended: 'Recommandé :',
        useTheAddress: 'Utiliser l’adresse que j’ai saisie',
        extendSessionTitle: 'Prolonger la session?',
        extendSessionButton: 'Prolonger la session',
        sessionExpireText: `Votre session expirera dans ${vars[0]} minutes et ${vars[1]} secondes en raison de votre inactivité.`,
        internationalShippingTitle: 'Expédition internationale',
        selectShippingCountry: 'Sélectionnez le pays dans lequel vous souhaitez être livré',
        redIndicationText: 'Remarque : Les articles ne pouvant pas être expédiés à l’emplacement sélectionné seront indiqués en rouge.',
        itemsWillBeRemovedText: 'Afin de passer à la caisse, ces articles devront être supprimés de votre panier.',
        continueWithShippingToUs: 'Continuer avec l’expédition aux États-Unis.',
        ifYouSelectCanadianShipping: 'Si vous optez pour l’expédition au Canada, vous serez redirigé vers le site canadien.',
        pricesWillBeShown: 'Les prix seront affichés en',
        atCheckoutOnly: 'à la caisse seulement'
    };

    return resources[label];
};
